export default __webpack_public_path__ + "static/media/teller-logo-full-white.57d46124.svg";